import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchCommunitylist = async () => {
  
  try {
    const response = await fetch(`${API_URL}/travelcommunity_list`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("API Error:", error);
    return null;
  }
};
